<section
  *ngIf="{ isFormChanged: isFormChanged$ | async } as resolved"
  class="custom-section">
  <customer-title-content
    [title]="labels.inverterListTitle"
    [content]="labels.inverterListDescription">
  </customer-title-content>
  <section class="max-h-100 fx-r-col overflow-y-auto fx-gap-3 pt-3 border-t-1 border-greylight-100">
    <ng-container *ngFor="let inverter of virtualDevicesConfig.controls.inverterList.controls; let index = index">
      <ng-container *ngIf="!inverter.controls.added.value; else registered">
        <div class="fx-row fx-wrap fx-gap-3 pos-sticky inset-b-0 py-1">
          <customer-simple-input
            class="fx-g-1 min-h-15"
            data-testid="device-serial-input"
            [placeholder]="labels.inverterListPlaceholder"
            [input]="inverter.controls.inverterSerial"
            [errorMessage]="inverter.controls.inverterSerial.errors | deviceSerialValidatorPipe : labels">
          </customer-simple-input>
          <customer-simple-button
            data-testid="device-serial-add-button"
            [label]="labels.addInverter"
            [disabled]="inverter.controls.inverterSerial.invalid || inverter.controls.inverterSerial.pending"
            [action]="addVirtualInverter(inverter)">
          </customer-simple-button>
        </div>
      </ng-container>

      <ng-template #registered>
        <app-card-accordion
          class="card-accordion-bg-green fx-g-1"
          mode="card">
          <customer-item
            *ngIf="internalManagement; else externalManagement"
            [attr.data-testid]="inverter.controls.inverterSerial.value + '-item'"
            [svgIcon]="(inverter.controls.inverterSerial.value || '') | apply : getDeviceIconIdentifier"
            [deviceItemContent]="inverter.controls.inverterSerial.value || ''"
            [ngClass]="{
              'item-uninstall': inverter.controls.dismiss.value === 'Uninstall',
              'item-delete': inverter.controls.dismiss.value === 'Delete',
            }"
            [primaryAction]="inverter.controls.dismiss.value ? {
              classes: 'text-grey-300',
              icon: 'undo',
              clickFn: internalManagementDismiss(index),
            } : {
              classes: 'text-grey-300',
              icon: 'archive',
              hoverText: labels.uninstall,
              clickFn: internalManagementDismiss(index, 'Uninstall'),
            }"
            [secondaryAction]="inverter.controls.dismiss.value
              ? undefined
              : {
              classes: 'text-red-400',
              icon: 'delete',
              hoverText: labels.delete,
              clickFn: internalManagementDismiss(index, 'Delete'),
            }">
          </customer-item>

          <ng-template #externalManagement>
            <customer-item
              [svgIcon]="(inverter.controls.inverterSerial.value || '') | apply : getDeviceIconIdentifier"
              [deviceItemContent]="inverter.controls.inverterSerial.value || ''"
              [primaryAction]="{
                classes: '',
                icon: 'delete',
                clickFn: removeVirtualInverter(index),
              }">
            </customer-item>
          </ng-template>
        </app-card-accordion>
      </ng-template>
    </ng-container>
  </section>

  <mat-chip-set *ngIf="internalManagement">
    <mat-chip
      *ngFor="let opt of options"
      [ngStyle]="{
        '--mdc-chip-label-text-color': opt === 'active'
          ? 'var(--color-accent)' : opt === 'uninstall'
            ? 'var(--color-grey-400)' : 'var(--color-red-400)',
      }"
      [ngClass]="{
        'bg-accent-100 text-accent border-accent': opt === 'active',
        'bg-grey-100 text-grey-400 border-grey-400': opt === 'uninstall',
        'bg-red-100 text-red-400 border-red-400': opt === 'delete',
      }">
      <mat-icon
        *ngIf="opt === 'uninstall' || opt === 'delete'"
        matChipAvatar
        [ngClass]="{
          'text-grey-400': opt === 'uninstall',
          'text-red-400': opt === 'delete',
        }">
        {{ opt === 'uninstall' ? 'archive' : 'delete' }}
      </mat-icon>
      {{ labels[opt] }}
    </mat-chip>
  </mat-chip-set>

  <div
    *ngIf="internalManagement && resolved.isFormChanged"
    class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-grey-400 text-300 body-2">
    <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100 w-full">
      <mat-icon class="text-orange-400">
        info
      </mat-icon>
      <customer-title-content
        class="fx-g-1"
        [content]="labels.thereAreUnsavedChanges">
      </customer-title-content>
    </section>
  </div>
</section>
